import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { getCheapestInsights } from "@/lib/cheapestPrices.functions";
import { spotPriceLoader } from "@/lib/spotSnapshot";
import { jsonLdHeadScript, spotPriceDatasetJsonLd } from "@/lib/structuredData";

const ElPriserMain = lazy(() => import("@/pages/ElPriserMain"));

export const Route = createFileRoute("/elpriser/")({
  loader: async () => {
    const [insights, { spotSnapshot }] = await Promise.all([getCheapestInsights(), spotPriceLoader()]);
    return { insights, spotSnapshot };
  },
  head: () => ({
    ...seoHead("/elpriser", {
      description:
        "Elpriser idag och imorgon för SE1–SE4. Se när elen är billigast idag, billigaste timmen imorgon och historiskt billigaste månaden – direkt ur spotprisdata.",
    }),
    // Spotpriserna som Dataset, med elpris-API:t som distribution.
    scripts: [jsonLdHeadScript(spotPriceDatasetJsonLd("/elpriser"))],
  }),
  component: ElPriserRoute,
});

function ElPriserRoute() {
  const { insights } = Route.useLoaderData();
  return <ElPriserMain insights={insights ?? null} />;
}
